/*  ____                        _
   |  _ \ ___  __ _ _ __  _   _| |_ ___
   | |_) / _ \/ _` | '_ \| | | | __/ __|
   |  __/  __/ (_| | | | | |_| | |_\__ \
   |_|   \___|\__,_|_| |_|\__,_|\__|___/
   https://peanuts.no
*/

// TODO: Move parts of this to separate javascript files for clarity

(function ($) {
    // This thing here finds all external links and adds target _blank and cssClass external
    $('a[href^="//"],a[href^="http"]').not('[href*="' + window.location.hostname + '"]').attr("target", "_blank").addClass("external");

    // Add .no-target-icon to anchors with image inside
    $('a img').parent("a").addClass("no-target-icon");

    $('a[href^="mailto:"]').each(function (index, item) {
        $(item).html(
            $(item).html().replace("@", "@&#8203;")
        );

    });

    // Wrap iframe embeds in div for responsiveness
    $("iframe[src*='google.com/maps/embed?']").each(function (index, item) {
        $(item).wrap("<div class=\"embed-responsive embed-responsive--maps\"></div>");
    });
    $("iframe[src*='google.com/maps/d/embed?']").each(function (index, item) {
        $(item).wrap("<div class=\"embed-responsive embed-responsive--maps\"></div>");
    });
    $("iframe[src*='youtube.com/embed']").each(function (index, item) {
        $(item).wrap("<div class=\"embed-responsive embed-responsive--youtube\"></div>");
    });
    $("iframe[src*='facebook.com/plugins/']").each(function (index, item) {
        $(item).wrap("<div class=\"facebook-embed-responsive\"></div>");
    });
    $("iframe[src*='GmiWeb.Meld.Mobil']").each(function (index, item) {
        $(item).wrap("<div class=\"gmiweb-embed-responsive\"></div>");
    });

    // Show or hide "go-to-top" button
    $(window).scroll(function () {
        if ($(this).scrollTop() >= 25) {
            $('.go-to-top').addClass('go-to-top--visible');
        } else {
            $(".go-to-top").removeClass('go-to-top--visible');
        }
    });

    // Scroll to the top on "go-to-top" button click
    $(".go-to-top").click(function () {
        $('html,body').animate({ scrollTop: 0 }, 'slow');
        return false;
    });

    // Shrink or grow header based on scroll position
    $(window).scroll(function () {
        if ($(document).scrollTop() > 50) {
            $('header').addClass('shrink');
            $('#megaMenu').addClass('shrink');
        } else {
            $('header').removeClass('shrink');
            $('#megaMenu').removeClass('shrink');
        }
    });

    $(".search-page .toggle-filter").click(function () {
        $(".toggle-filter-container").toggleClass("open");
        $(".search-filter").toggle();
    });

    $(".accordion__section button").click(function () {
        var current = $(this).parent();
        if ($(current).hasClass("accordion__section--open")) {
            $(current).removeClass("accordion__section--open");
            $(current).children(".accordion__section__content").slideUp();
        } else {
            $(current).siblings().removeClass("accordion__section--open");
            $(current).siblings().children(".accordion__section__content").slideUp();

            $(current).addClass("accordion__section--open");
            $(current).children(".accordion__section__content").slideDown();
        }
    });

    $(".language-selector h2").click(function () {
        $(this).parent().toggleClass("language-selector--open");
    });

    $(".menusectionblock .toggle-button, .menusectionblock h3").click(function () {
        var parent = $(this).parent();
        if (parent.hasClass("open")) {
            parent.removeClass("open");
        } else {
            parent.addClass("open");
            parent.siblings().removeClass("open");
        }
    });

    // Find headings, add anchors, add anchor links
    // A copy (the school page repeats the list above the sidebar for phones) gets the same links, but the
    // headings are looked up from the original.
    var anchorlinks = $(".anchorlinks").not(".anchorlinks--copy")[0];
    var container = $(anchorlinks).parent();
    // The school page takes the sidebar along, in page order: on phones it comes before the main column.
    // The language selector's heading is a toggle, not a section.
    var $headings = $(".school-page").length >= 1
        ? $(".school-page .sidebar h2, .school-page .mainbody h2").not(".language-selector h2")
        : $(container).find(".mainbody h2, .linklist h2, .contactinfo h2");

    // The school page keeps the list from one heading: on phones it is the way past the long sidebar.
    var minimumHeadings = $(".school-page").length >= 1 ? 1 : 3;
    var shouldBeHidden =
        ($(".entity-page").length >= 1 || $(".embedded-report-page").length >= 1)
        && $headings.length < minimumHeadings;

    if (shouldBeHidden) {
        $(".anchorlinks").hide();
    }

    $headings.each(function (index, item) {
        var title = $(item).text().trim();
        // A heading's own id stays: aria-labelledby may point at it.
        var slug = item.id;

        if (!slug) {
            var base = title.replace(/[^A-Z0-9]+/ig, "-").toLowerCase();
            var number = 2;
            slug = base;

            // Two headings with the same text (contact info in both the sidebar and the main column) each need their own id.
            while (slug && document.getElementById(slug)) {
                slug = base + "-" + number++;
            }

            $(item).attr("id", slug);
        }

        if (title.length > 0) {
            $(".anchorlinks").append($("<li>").append($("<a>").attr("href", "#" + slug).text(title)));
        }
    });
    $(".landing-page .secondbody").find(".contentblock h2, .image-and-content-block h2").each(function (index, item) {

        var title = $(item).text().trim();
        var slug = title.replace(/[^A-Z0-9]+/ig, "-").toLowerCase();

        $(item).attr("id", slug);
        if (title.length > 0) {
            $(".anchorlinks").append($("<li>").append($("<a>").attr("href", "#" + slug).html(title)));
        }
    });

    // Add noscroll to body if megamenu is open
    $('.menu-toggle').on('click', function (e) {
        if ($("#megaMenu").is(":visible")) {
            $(this).children("span.text").html($(this).data("open-text"))
            $("body").removeClass("no-scroll");
        } else {
            $(this).children("span.text").html($(this).data("close-text"))
            $("body").addClass("no-scroll");
        }
    });

    // Add noscroll to body if mobilemenu is open
    $('#mobileMenuToggler').on('click', function (e) {
        e.preventDefault();
        const mobileMenu = $('#mobileMenu');
        mobileMenu.toggleClass('visible');
        if (mobileMenu.hasClass('visible')) {
            $(this).removeClass('collapsed');
            $('body').addClass('no-scroll');
        } else {
            $(this).addClass('collapsed')
            $('body').removeClass('no-scroll');
        }
    });

    $('#mobileMenu .main-menu-mobile-category-toggle').on('click', function(e) {
        e.preventDefault();
        var $children = $(this).closest('.main-menu-mobile-category').find('.main-menu-mobile-links');
        $children.slideToggle();
        $(this).find('.arrow').toggleClass('open');
    });

    // Smooth scroll to heading on anchor link clik
    $('a[href^="#"]').on('click', scrollSmoothly);

    // Hide search bar when menu is shown
    $('#megaMenu').on('show.bs.collapse', function (e) {
        $('#searchBar').collapse('hide');
    });

    // Hide menu when search bar is shown
    $('#searchBar').on('show.bs.collapse', function (e) {
        $('#megaMenu').collapse('hide');

        // Do not show header search bar if on the start page,
        // just focus start page hero search bar
        if ($("body").is(".start-page")) {
            e.preventDefault();

            var input = $("#hero-search input[type=text]");
            input.focus();
        }

        // Do not show header search bar if on the search page,
        // just focus search page search field
        if ($("body").is(".search-page")) {
            e.preventDefault();

            var input = $(".search-wrapper input[type=text]");
            input.focus();
        }
    });

    // Hook up panel close button
    $("#searchBar-close-button").click(function () {
        $('#searchBar').collapse('hide');
    });

    // Focus to search bar after shown
    $('#searchBar').on('shown.bs.collapse', function (e) {
        var input = $('#searchBar input[type=text]');
        input.focus();
    });

    // Don't do anything on share link click
    $("a.share-link").click(function (e) {
        e.preventDefault();
    });

    // Show browser print dialog on print link click
    $("a.print-link").click(function (e) {
        window.print();
        e.preventDefault();
    });

    if (storageAvailable('sessionStorage')) {
        var betaClosed = sessionStorage.getItem("betaClosed");
        if (betaClosed && betaClosed == "closed")
        {
            $(".beta-ribbon").addClass("closed");
        } else {
            $(".beta-ribbon").removeClass("closed");
        }
    }

    $(".beta-ribbon button.close").click(function (e) {
        $(this).parent().parent().addClass("closed");
        if (storageAvailable('sessionStorage')) {
            sessionStorage.setItem("betaClosed", "closed");
        }
    });

})(jQuery);

function scrollSmoothly(e) {
    e.preventDefault();

    var target = this.hash;
    var $target = $(target);

    if ($target.length) {
        $('html, body').stop().animate({
            'scrollTop': $target.offset().top
        }, 900, 'swing', function () {
            window.location.hash = target;
        });
    }
}

window.scrollSmoothly = scrollSmoothly;

function storageAvailable(type) {
    try {
        var storage = window[type],
            x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    }
    catch (e) {
        return e instanceof DOMException && (
                // everything except Firefox
                e.code === 22 ||
                // Firefox
                e.code === 1014 ||
                // test name field too, because code might not be present
                // everything except Firefox
                e.name === 'QuotaExceededError' ||
                // Firefox
                e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
            // acknowledge QuotaExceededError only if there's something already stored
            storage.length !== 0;
    }
}

window.storageAvailable = storageAvailable;

function responsiveTables(parentSelector) {
    document.querySelectorAll(parentSelector + ' table').forEach(table => {
        let wrapper = document.createElement('div');
        wrapper.classList.add('responsive-table');
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
}

window.responsiveTables = responsiveTables;

responsiveTables(".plan__content");